import * as React from 'react';
import styled from 'styled-components';
import { OnlineThemeType } from '../../themes/online';
import sunbitFlowerLoader from '../../assets/sunbit-flower-white.svg';
import sunbitFlower3 from '../../assets/sunbit-flower-3.svg';
import sunbitFlower6 from '../../assets/sunbit-flower-6.svg';
import sunbitFlower12 from '../../assets/sunbit-flower-12.svg';

// ############################ Styles ###########################
// tslint:disable:variable-name

const getNumberIcon = (number: number) => {
  switch (number) {
    case 999:
      return sunbitFlowerLoader;
    case 0:
      return sunbitFlower3;
    case 1:
      return sunbitFlower6;
    case 2:
      return sunbitFlower12;
    default:
      return '';
  }
};

const getColor = (theme: OnlineThemeType, flavor: string) => {
  switch (flavor) {
    case 'white':
      return `
        background-color: white;
        color: ${theme.colors.primaryBackground};
        `;
    case 'blue':
      return `
        background-color: ${theme.colors.primaryBackground};
        color: white;
      `;
    case 'transparent':
      return `
        background-color: "transparent";
        color: white;
      `;
    default:
      break;
  }
};

export const SWrapper = styled.div(({ theme }) => {
  return `
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 62px;
    width: 62px;
    flex-shrink: 0;
    @media only screen and ${theme.device.laptop} {
      height: 50px;
      width: 50px;
    }
  `;
});

const SDynamicIcon = styled.img<{ flavor: string }>(({ theme, flavor }) => {
  return `
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    ${getColor(theme, flavor)}
  `;
});

const SPaymentNumberText = styled.p(({ theme }) => {
  return `
    position: absolute;
    font-familiy: Poppins;
    font-size: 16px;
    font-weight: ${theme.font.weight.bolder};
  `;
});

// tslint:enable:variable-name
// ############################ End Styles ###########################

export interface IIconProps {
  dataAt?: string;
  number: number;
  cardIndex: number;
  flavor?: string;
}

export default ({ dataAt, number = 3, cardIndex = 0, flavor = 'blue' }: IIconProps) => {
  return (
    <SWrapper>
      <SDynamicIcon src={getNumberIcon(cardIndex)} data-at={dataAt} flavor={flavor}></SDynamicIcon>
      {number > 0 && <SPaymentNumberText>{number}</SPaymentNumberText>}
    </SWrapper>
  );
};
